import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import { disabled } from '@monorepo/shared/src/styles/sharedStyles';
import { BOOK_COVER_HEIGHT, BookCoverProps, BOOK_COVER_WIDTH, AppRoutes } from 'types';

const BookCover: React.FC<BookCoverProps> = (cover) => {
  const classes = styles();
  return (
    <Link
      to={{
        pathname: `/${AppRoutes.READ_BOOK}/${cover.routeParam}`,
      }}
      state={{
        title: cover.title,
        from: location.pathname,
      }}
      className={clsx(cover.disabled && classes.disabled)}
    >
      <div className={classes.iframeContainer}>
        <iframe
          frameBorder={0}
          className={classes.cover}
          scrolling="no"
          srcDoc={cover.html}
          title={cover.title}
        ></iframe>
        <div className={classes.iframeOverlay}></div>
      </div>
    </Link>
  );
};

const styles = makeStyles((theme) => ({
  cover: {
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    boxShadow: '4px 8px 12px 0 rgba(0,0,0,0.2)',
    height: '100%',
    width: '100%',
  },
  disabled: disabled,
  iframeContainer: {
    position: 'relative',
    height: theme.typography.pxToRem(BOOK_COVER_HEIGHT),
    width: theme.typography.pxToRem(BOOK_COVER_WIDTH),
  },
  iframeOverlay: {
    height: '100%',
    left: '0',
    position: 'absolute',
    top: '0',
    width: '100%',
  },
}));

export default BookCover;
